import { ReceiptPaperModule } from './../receipt-paper/receipt-paper.module'
import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'

import { OrderReceiptComponent } from './order-receipt.component'

import { SharedModule } from '../shared.module'
import { ProgressBarModule } from '../progress-bar/progress-bar.module'
import { IllustrationModule } from './../illustration/illustration.module'
import { TranslatePropertyModule } from '../pipes/translate-property/translate-property.module'
@NgModule({
	declarations: [OrderReceiptComponent],
	imports: [
		CommonModule,
		TranslatePropertyModule,
		SharedModule,
		ProgressBarModule,
		IllustrationModule,
		ReceiptPaperModule,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	exports: [OrderReceiptComponent],
})
export class OrderReceiptModule {}
